module.exports = __webpack_public_path__ + "media/images/banner/about_banner-16730a5fd87ad8207548166669eff139.jpg";